export default __webpack_public_path__ + "static/media/orders.ee6a14cd.svg";